module.exports = __webpack_public_path__ + "img/Mail.0fb1de94.webp";